<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">
                        <el-button type="primary" size="small" @click="add"  icon="el-icon-plus" plain>添加</el-button>
                         <el-input
                            size="small"
                            style="width:300px;margin-left:30px;"
                            placeholder="请输入佣金模板名称"
                            prefix-icon="el-icon-search"
                            @keydown.enter.native="query"
                            v-model="queryModel.queryTxt">
                        </el-input>
                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:30px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="重置" placement="top">
                            <el-button type="primary" size="small" style="margin-left:15px;" @click="reset" icon="el-icon-aim" plain circle></el-button>
                        </el-tooltip>
                        <el-pagination
                        style="float:right"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryModel.pIndex"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="queryModel.pSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                    <el-table
                    v-loading="isLoading"
                    :height="bodyHeight-130"
                    :data="tableData"
                    style="width: 100%">
                        <el-table-column
                            prop="Name"
                            width="180px"
                            label="模板名称">
                        </el-table-column>
                        <el-table-column
                            prop="Remark"
                            width="400px"
                            label="备注">
                        </el-table-column>
                        <el-table-column
                            prop="ManagerName"
                            label="创建人"
                            width="100px">
                        </el-table-column>
                        <el-table-column
                            prop="CreateTime"
                            label="创建时间"
                            width="160px">
                        </el-table-column>
                        <el-table-column
                            label="内容">
                            <template slot-scope="scope">
                                <el-tag effect="dark" style="margin-left:5px" size="mini" :key="i" v-for="(v,i) in scope.row.Details">
                                    ≤{{v.CriticalValue}}:￥{{v.Commission}}&￥{{v.SwipeCommission}}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            width="80px">
                            <template slot-scope="scope">
                                <el-button type="danger" size="mini" @click="del(scope.row)"  icon="el-icon-delete" circle></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog title="添加佣金模板" :visible.sync="dialogFormVisible" width="480px">
            <el-form :model="newModel"  :rules="rules" ref="ruleForm" label-width="80px">
                <el-form-item label="名称：" prop="Name">
                    <el-input placeholder="请输入模板名称" v-model="newModel.Name"></el-input>
                </el-form-item>
                <el-form-item label="备注：" prop="Remark">
                    <!-- <el-input placeholder="如有需要，填写备注" v-model="newModel.Remark"></el-input> -->
                        <el-input
                        type="textarea"
                        :rows="2"
                        placeholder="如有需要，填写备注"
                        v-model="newModel.Remark">
                        </el-input>
                </el-form-item>
                <el-form-item label="内容：">
                    <div>
                        <el-input style="width:160px" v-model="criticalValue" placeholder="≤商品价格"></el-input>
                        ：
                        <el-input icon="el-icon-money" style="width:80px" v-model="commission" placeholder="￥佣金"></el-input>
                        <el-input icon="el-icon-money" style="width:80px;margin-left:10px" v-model="swipeCommission" placeholder="￥刷手"></el-input>
                    </div>
                    <div>
                        <el-button  size="mini" @click="addDetail"  icon="el-icon-plus" plain>添加</el-button>
                    </div>
                    <el-tag effect="dark" style="margin-left:10px" size="mini" :key="i" v-for="(v,i) in newModel.Details">
                                    ≤{{v.CriticalValue}}:￥{{v.Commission}}&￥{{v.SwipeCommission}}
                    </el-tag>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { commissionGet,commissionDel,commissionAdd} from '@/request.js'

export default {
    data(){
        return {
            prevCriticalValue:0,
            criticalValue:"",
            commission:"",
            swipeCommission:"",
            dialogFormVisible:false,
            total:0,
            bodyHeight:0,
            isLoading:false,
            queryModel:{
                queryTxt:"",
                pSize:20,
                pIndex:1,
            },
            tableData:[],
            newModel:{
                Id:0,
                Name:"",
                Remark:"",
                Details:[],
            },
            rules: {
                Name: [
                    { required: true, message: '请填写佣金模板名称', trigger: 'blur' },
                    { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
                ],
                Remark: [
                    { min: 0, max: 50, message: '长度在 50 个字符以内', trigger: 'blur' }
                ],
            }
        }
    },
    created(){
        this.bodyHeight=document.documentElement.clientHeight-129;
        this.query();
    },
    mounted(){
       
    },
    methods: {
        submitForm() {
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    commissionAdd({
                        Name:this.newModel.Name,
                        Remark:this.newModel.Remark,
                        DetailJson:JSON.stringify(this.newModel.Details)
                    },(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '添加成功',
                                type: 'success'
                            });
                            this.dialogFormVisible=false;
                            this.query();
                        }else{
                            this.$message.error(res.Message);
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        addDetail(){
             var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
             if(reg.test(this.criticalValue)&&reg.test(this.commission)&&reg.test(this.swipeCommission)){
                if(parseFloat(this.criticalValue)<=parseFloat(this.prevCriticalValue)){
                    this.$message({
                        message: '商品价格必须大于上一次输入',
                        type: 'warning'
                    });
                }else{
                    this.newModel.Details.push({CriticalValue:this.criticalValue,Commission:this.commission,SwipeCommission:this.swipeCommission});
                    this.prevCriticalValue=this.criticalValue;
                } 
             }else{
                this.$message({
                    message: '请输入正确的金额',
                    type: 'warning'
                });
             }
        },
        add(){
            this.newModel={
                Id:0,
                Name:"",
                Remark:"",
                Details:[],
            };
            this.dialogFormVisible=true;
            this.prevCriticalValue=0;
        },
        del(scope){
            this.$confirm('确认删除该佣金模板吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                commissionDel({id:scope.Id},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.tableData.forEach((item, index, arr)=>{
                            if(item==scope){
                                arr.splice(index, 1);
                            }
                        });
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        query(){
            this.isLoading=true;
            commissionGet(this.queryModel,(res)=>{
                this.tableData=res.Result;
                this.total=res.TotalCount;
                setTimeout(() => {
                    this.isLoading=false;
                }, 300);
            })
        },
        reset(){
            this.queryModel={
                queryTxt:"",
                pSize:this.queryModel.pSize,
                pIndex:this.queryModel.pIndex,
            }
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        }
    }
}
</script>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>